import React, { useState } from 'react';
import { Modal, Form, Input, Rate, Button, Select, message, Typography } from 'antd';
import { StarOutlined } from '@ant-design/icons';
import inspectionService from '@/services/inspection.service';
import toast from "react-hot-toast";
import InspectionBtn from '@/components/InspectionBtn';

const { TextArea } = Input;
const { Option } = Select;

const FeedbackModal = ({ visible, onClose, onSaveFeedback }) => {
  const [form] = Form.useForm();
  const [rating, setRating] = useState(0);
  const [comments, setComment] = useState("");

  const handleSubmit = async (values) => {
    try {
      const payload = {
        comments,
        rating,
      }
     await onSaveFeedback(payload)
       setRating(0);
      onClose();
    } catch (error) {
      toast.error('Failed to submit feedback');
    }
  };

  const handleCancel = () => {
     setRating(0);
    onClose();
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2 text-lg font-semibold text-gray-800">
          <StarOutlined className="text-green-500" />
          Share Your Feedback
        </div>
      }
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={500}
      className="feedback-modal"
    >
      <div  className='p-2'>
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          className="space-y-4"
        >


          <Form.Item

            required
            className="mb-4"
          >
            <Typography.Text strong >  Rating</Typography.Text>
            <div className="flex flex-col mt-3  space-y-2">
              <Rate
                value={rating}
                onChange={setRating}
                className="text-2xl"
                character={<StarOutlined />}
              />
              <span className="text-sm text-gray-600">
                {rating === 0 && 'Please rate your experience'}
                {rating === 1 && 'Poor'}
                {rating === 2 && 'Fair'}
                {rating === 3 && 'Good'}
                {rating === 4 && 'Very Good'}
                {rating === 5 && 'Excellent'}
              </span>
            </div>
          </Form.Item>

          <Form.Item
            name="comments"
          >
            <Typography.Text strong >  Comments</Typography.Text>

            <TextArea
              rows={4}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Share your detailed feedback..."
              className="mt-3 rounded-md "
            />
          </Form.Item>

          <div className="flex gap-3 pt-4">
            <InspectionBtn variant='secondary'
              onClick={handleCancel}
              className="flex-1 h-10 rounded-md"
            >
              Cancel
            </InspectionBtn>
            <InspectionBtn
              type="primary"
              htmlType="submit"
              disabled={rating === 0}
              className="flex-1 h-10 rounded-md bg-green-600 hover:bg-green-700"
            >
              Submit Feedback
            </InspectionBtn>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default FeedbackModal;
